import * as React from 'react';
import { connect } from 'react-redux';
import { Form, InputGroup, Image, Button } from 'react-bootstrap';
import '../ClaimsHistory/ClaimsHistory.css';
import ClaimInfo from '../ClaimsHistory/ClaimInfo'
import { DASHBOARD, CLAIMS } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import ClaimsCard from './ClaimsCard';
import { showCallMeModal } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import NeedHelp from '../../../../src/components/BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';

class ClaimsHistory extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentNav: "Claims History",
            searchText: "",
        };
        this.handleNav = this.handleNav.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    async handleNav(e: any) {
        let name = e.target.name;
        let value = e.target.id;
        await this.setState({ [name]: value });
    }

    handleClick(id) {
        this.setState({ currentNav: id });
    }

    public render() {

        const { profile } = this.props;

        let covers = <div></div>;
        if (profile.personalClaims !== undefined && profile.personalClaims !== "") {
            covers = this.props.profile.personalClaims
                .filter((cover) => cover.claimTitle.toUpperCase().includes(this.state.searchText.toUpperCase()) || cover.riskItem.toUpperCase().includes(this.state.searchText.toUpperCase()))
                .map((cover) => {
                    return <div key={cover.claimNumber} >
                        <ClaimsCard id={cover.claimNumber} alertCount="0"
                            headerText={cover.claimTitle}
                            bodyText={cover.riskItem}
                            claimStatus={cover.claimStatus}
                        />
                    </div>
            });
        }

        let nav = () =>
            <div id="PersonalDetails">
                <div className="row">
                    <div className="col-12">
                        <div id="ClaimsHistory" className="card col-12 mb-3">
                            <div className="card-body">
                                <div className="">
                                    <h3 className="mb-2 text-white">Claims history</h3>
                                </div>
                                <div className="mb-lg-1">
                                    <p className="text-white">Check out all the claims you've submitted</p>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 center-text">
                            <InputGroup>
                                <Form.Control type="text" placeholder="Search" id="searchClaims" name="searchText" value={this.state.searchText} onChange={this.handleChange} />
                            </InputGroup>
                        </div>
                        {covers}
                    </div>
                </div>
            </div >

        let info = () =>
            <>
                <ClaimInfo />
                <NeedHelp
                    isClaims={true}
                    countryId={this.props.profile.countryId}
                    claimsEmail={this.props.ssp.claims_email}
                    contactUsTel={this.props.ssp.contactUs_tel}
                    handleCallMeBack={(e) => this.handleCallMeBack(e)}
                />
            </>
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: CLAIMS, description: "Claims" }]

        return (
            <div id="ClaimHistory">
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Claims history" />
                <div className="d-none d-xl-block">
                    <div className="row">
                        <div className="mb-3 col-4">
                            {nav()}
                        </div>
                        <div className="mb-3 col-8">
                            {info()}
                        </div>
                    </div>
                </div>
                <div className="d-xl-none">
                    <div className="mb-3">
                        {nav()}
                    </div>
                    <div className="mb-3">
                        {info()}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsHistory);